module.exports = __webpack_public_path__ + "img/Feature.4a8f3e12.jpg";